// GET /api/rights: пояснения ролей и матрица (FR-015а).
import { z } from '../kernel/zod.ts';
import {
  OperationSchema,
  ScopeRuleSchema,
  protocolRules,
  rightsProtocolColumns,
} from '../rights/matrix.ts';
import { RoleSchema } from '../rights/roles.ts';

export const MatrixCellViewSchema = z.object({
  rule: z.union([ScopeRuleSchema, z.literal('same_as')]),
  /** Подпись как в документе: «всё», «сам (своя роль)», «как audit.read.*». */
  label: z.string(),
  note: z.string().optional(),
  sameAs: z.array(OperationSchema).optional(),
});

const ProtocolRuleViewSchema = z.object({ rule: z.enum(protocolRules), label: z.string() });

/** Ячейка «Роли в протоколе»; zone — у «Редактора», если с зоной правило уже (041, FR-007). */
const ProtocolCellViewSchema = ProtocolRuleViewSchema.extend({
  zone: ProtocolRuleViewSchema.optional(),
});

/** 040 (FR-019): колонки «Роли в компании», слои ролей, вторая таблица «Роли в протоколе». */
export const RightsResponseSchema = z.object({
  roles: z.array(z.object({ role: RoleSchema, title: z.string(), description: z.string() })),
  layers: z.array(
    z.object({
      key: z.enum(['company', 'protocol', 'item']),
      title: z.string(),
      roles: z.array(z.object({ key: z.string(), title: z.string(), description: z.string() })),
    }),
  ),
  /**
   * Правило «в сеансе» (FR-011а): эти операции над своим («сам») даёт сам сеанс — любому
   * пользователю, даже без ролей, сверх ячеек матрицы.
   */
  inSession: z.array(OperationSchema),
  matrix: z.array(
    z.object({
      operations: z.array(OperationSchema),
      description: z.string().optional(),
      cells: z.record(RoleSchema, MatrixCellViewSchema),
    }),
  ),
  protocolMatrix: z.array(
    z.object({
      operations: z.array(OperationSchema),
      cells: z.record(z.enum(rightsProtocolColumns), ProtocolCellViewSchema),
    }),
  ),
});
export type RightsResponse = z.infer<typeof RightsResponseSchema>;
